export const ACCOUNT_COOKIE_NAME = 'songwhip.accountId';
export const ACCOUNT_HEADER = 'x-songwhip-account-id';
export const APP_HOME_PATH = '/create';
